<template>
  <section>
    <VerDetallePersona />
    <v-card>
      <v-layout row wrap>
        <v-flex xs12>
          <!-- Boton filtro -->
          <v-tooltip bottom>
            <v-btn
              @click.native="closeFilterSlide()"
              class="btn-refresh"
              slot="activator"
              ><v-icon>filter_list</v-icon>
            </v-btn>
            <span>Búsqueda/filtros</span>
          </v-tooltip>
          <!-- Boton acutualizar -->
          <v-tooltip bottom>
            <v-btn
              @click.native="actualizaLista(0, 1)"
              class="btn-refresh"
              slot="activator"
              ><v-icon>refresh</v-icon>
            </v-btn>
            <span>{{ $t("common.updateList") }}</span>
          </v-tooltip>
          <!-- Filtros-->
        </v-flex>
        <v-flex xs12>
          <v-card-text class="p-0 mb-2">
            <!-- Filtros-->
            <v-flex xs12>
              <transition name="slide-fade">
                <div class="filter-container" v-show="filterShow">
                  <v-icon small color="primary">search</v-icon>
                  <div class="filter-item">
                    <v-text-field
                      class="text-field-reducido"
                      label="CI"
                      type="text"
                      v-model="filter_slide.nro_doc"
                      clearable
                      @input="actualizaLista(0, 1)"
                    ></v-text-field>
                  </div>
                  <div class="filter-item">
                    <v-text-field
                      class="text-field-reducido"
                      label="Ap paterno"
                      type="text"
                      v-model="filter_slide.ap_paterno"
                      clearable
                      @input="actualizaLista(0, 1)"
                    ></v-text-field>
                  </div>
                  <div class="filter-item">
                    <v-text-field
                      class="text-field-reducido"
                      label="Ap materno"
                      type="text"
                      v-model="filter_slide.ap_materno"
                      clearable
                      @input="actualizaLista(0, 1)"
                    ></v-text-field>
                  </div>
                  <div class="filter-item">
                    <v-text-field
                      class="text-field-reducido"
                      label="Nombres"
                      type="text"
                      v-model="filter_slide.nombres"
                      clearable
                      @input="actualizaLista(0, 1)"
                    ></v-text-field>
                  </div>
                  <div class="filter-item">
                    <v-text-field
                      class="text-field-reducido"
                      label="Nro item"
                      type="text"
                      v-model="filter_slide.nro_item"
                      clearable
                      @input="actualizaLista(0, 1)"
                    ></v-text-field>
                  </div>
                  <div class="filter-item">
                    <v-text-field
                      class="text-field-reducido"
                      label="Cargo"
                      type="text"
                      v-model="filter_slide.cargo"
                      clearable
                      @input="actualizaLista(0, 1)"
                    ></v-text-field>
                  </div>
                  <div class="filter-item">
                    <v-text-field
                      class="text-field-reducido"
                      label="Puesto"
                      type="text"
                      v-model="filter_slide.puesto"
                      clearable
                      @input="actualizaLista(0, 1)"
                    ></v-text-field>
                  </div>
                  <!-- <div class="filter-item">
                    <v-text-field
                      class="text-field-reducido"
                      label="Unidad"
                      type="text"
                      v-model="filter_slide.nombre_unidad"
                      clearable
                      @input="actualizaLista(0, 1)"
                    ></v-text-field>
                  </div> -->
                  <div class="filter-item">
                    <v-autocomplete
                      :items="l_unidades"
                      :item-value="
                        v => {
                          return v.nombre_unidad;
                        }
                      "
                      item-text="nombre_unidad"
                      v-model="filter_slide.nombre_unidad"
                      label="Tipo de activo"
                      clearable
                      @change="actualizaLista(0, 1)"
                    />
                  </div>
                  <!-- botones cerrar -->
                  <div class="btn-filter">
                    <v-tooltip bottom>
                      <v-btn
                        icon
                        slot="activator"
                        @click.native="closeFilterSlide()"
                      >
                        <v-icon small>close</v-icon>
                      </v-btn>
                      <span>Cerrar filtros</span>
                    </v-tooltip>
                  </div>
                </div>
              </transition>
            </v-flex>
          </v-card-text>
        </v-flex>
      </v-layout>
      <v-progress-linear
        :indeterminate="loading"
        height="2"
      ></v-progress-linear>
      <v-layout
        row
        wrap
        class="justify-space-between"
        v-if="vec_frame.length > 0"
      >
        <v-flex xs4 align-self-center class="text-xs-left px-2">
          <h5 class="font-weight-light blue--text m-0">
            {{ `TOTAL PERSONAS: ${total_items}` }}
          </h5>
        </v-flex>
        <v-flex shrink align-self-center>
          <v-btn icon large @click="actualizaLista(-1)" :disabled="page <= 1">
            <v-icon style="font-size:3em" color="blue">
              chevron_left
            </v-icon>
          </v-btn>
          <v-btn
            icon
            large
            @click="actualizaLista(1)"
            :disabled="total_paginas <= page"
          >
            <v-icon style="font-size:3em" color="blue">
              chevron_right
            </v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs4 align-self-center class="text-xs-right px-2">
          <h5 class="font-weight-light blue--text m-0">
            {{ `PAGINA ${this.page}/${total_paginas}` }}
          </h5>
        </v-flex>
        <!-- Contenedor -->
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex
              xs12
              sm6
              md3
              lg2
              xl2
              v-for="element in vec_frame"
              :key="element.id_persona"
              class="p-0"
            >
              <ItemSliderComponent
                :persona="element"
                id="content-card"
                :key="element.id_persona"
              />
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs4 align-self-center class="text-xs-left px-2">
          <h5 class="font-weight-light blue--text m-0">
            {{ `TOTAL PERSONAS: ${total_items}` }}
          </h5>
        </v-flex>
        <v-flex shrink align-self-center>
          <v-btn icon large @click="actualizaLista(-1)" :disabled="page <= 1">
            <v-icon style="font-size:3em" color="blue">
              chevron_left
            </v-icon>
          </v-btn>
          <v-btn
            icon
            large
            @click="actualizaLista(1)"
            :disabled="total_paginas <= page"
          >
            <v-icon style="font-size:3em" color="blue">
              chevron_right
            </v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs4 align-self-center class="text-xs-right px-2">
          <h5 class="font-weight-light blue--text m-0">
            {{ `PAGINA ${this.page}/${total_paginas}` }}
          </h5>
        </v-flex>
      </v-layout>
      <v-layout v-else>
        <v-flex xs12>
          <div
            class="font-weight-light grey--text title mb-2 text-xs-center py-3"
          >
            No se encontraron registros
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </section>
</template>

<script>
import ItemSliderComponent from "./ItemSliderComponent.vue";
import VerDetallePersona from "../dialogs/VerDetallePersona.vue";
export default {
  components: { ItemSliderComponent, VerDetallePersona },
  props: ["filtros"],
  // Variables iniciales
  data() {
    return {
      loading: false,
      l_tipo_activos: [],
      l_ubicaciones_fisicas: [],
      vec_frame: [],
      filterShow: true,
      filter_slide: {},
      page: 1,
      limit: 1,
      total_items: null,
      l_unidades: []
    };
  },
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    total_paginas() {
      return Math.ceil(this.total_items / this.limit);
    }
  },
  watch: {
    breakpoint(newVal, oldVal) {
      this.actualizaLista(0);
    },
    // Metodo para actualizar el listado cuando se cambian los filtros del padre
    filtros: {
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.actualizaLista(0);
        }
      },
      deep: false
    }
  },
  async created() {
    this.vec_frame = await this.cargarPersonas(this.filtros);
    this.l_unidades = await this.$query.select(
      "unidad",
      { id_entidad: 35, id_estado: 17 },
      ["nombre_unidad", "id"]
    );
    // setInterval(() => {
    //   this.imprimePosicion();
    // }, 1000);
  },
  async mounted() {},
  methods: {
    imprimePosicion() {
      const xScrollPosition = window.pageYOffset;
      console.log(`Posición Horizontal (${xScrollPosition})`);
    },
    // Metodo para llevar la pantalla al incio
    async goToTop() {
      var position = window.pageYOffset;
      const pause = ms => new Promise(resolve => setTimeout(resolve, ms));
      while (position > 0) {
        position -= 50;
        window.scrollTo({ top: position });
        await pause(10);
      }
    },
    closeFilterSlide() {
      if (this.filterShow) {
        this.filterShow = false;
        this.filter_slide = {};
        this.actualizaLista(0);
      } else {
        this.filterShow = true;
      }
    },
    async actualizaLista(pagina, pagina_inicio = false) {
      if (pagina_inicio) {
        this.page = pagina_inicio;
      } else {
        this.page += pagina;
      }
      // Verificamos la pagina en la que se encuentra si se cambia el tamaño de pantalla
      while (
        Math.ceil(this.total_items / this.calculaTamanoPantalla()) <
          this.page &&
        this.page != 0
      ) {
        this.page -= 1;
      }
      this.goToTop();
      this.vec_frame = await this.cargarPersonas(this.filtros);
    },
    // Calcular tamaño pantalla
    calculaTamanoPantalla() {
      // Calculamos la cantidad de objetos a mostrar
      switch (this.breakpoint) {
        case "xs":
          this.limit = 5;
          break;
        case "sm":
          this.limit = 10;
          break;
        case "md":
          this.limit = 20;
          break;
        case "lg":
          this.limit = 30;
          break;
        case "xl":
          this.limit = 50;
          break;
        default:
      }
      return this.limit;
    },
    async cargarPersonas(filtros) {
      this.loading = true;
      try {
        // Paginacion
        let obj_filters = {};
        obj_filters = { ...filtros };
        // Recorremos los filtros del slide
        for (const key in this.filter_slide) {
          if (this.filter_slide[key]) {
            obj_filters[key] = this.filter_slide[key];
          } else {
            delete obj_filters[key];
          }
        }
        this.total_items = await this.$query.count(
          "v_lista_personal_activo",
          obj_filters
        );
        obj_filters.page = this.page;
        obj_filters.limit = this.calculaTamanoPantalla();
        obj_filters = { ...obj_filters, ...filtros };
        let lista_activos = this.$query.select(
          "v_lista_personal_activo",
          obj_filters,
          [
            "id_persona",
            "nro_doc",
            "ap_paterno",
            "ap_materno",
            "nombres",
            "nro_item",
            "puesto",
            "cargo",
            "foto",
            "nombre_unidad"
          ]
        );
        this.loading = false;
        return lista_activos;
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
    }
  }
};
</script>

<style>
.contenedor-principal {
  position: relative;
}
.btn-flecha {
  display: inline-block;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/reportes_lista_personal/components/SliderPersonas.vue